/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, Input } from "@angular/core";
var TabContent = (function () {
    function TabContent() {
        this.active = false;
    }
    return TabContent;
}());
export { TabContent };
TabContent.decorators = [
    { type: Component, args: [{
                selector: "clr-tab-content",
                template: "\n      <!--\n        ~ Copyright (c) 2016 VMware, Inc. All Rights Reserved.\n        ~ This software is released under MIT license.\n        ~ The full license information can be found in LICENSE in the root directory of this project.\n        -->\n\n      <section>\n          <ng-content></ng-content>\n      </section>\n    ",
                host: {
                    "[id]": "id",
                    "role": "tabpanel",
                    "[attr.aria-hidden]": "!active",
                    "[attr.aria-labelledby]": "ariaLabelledBy",
                    "[attr.data-hidden]": "!active",
                    "[class.active]": "active"
                }
            },] },
];
/** @nocollapse */
TabContent.ctorParameters = function () { return []; };
TabContent.propDecorators = {
    'active': [{ type: Input, args: ["clrTabContentActive",] },],
    'id': [{ type: Input, args: ["clrTabContentId",] },],
};
//# sourceMappingURL=tab-content.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/tabs/tab-content.js
// module id = 57
// module chunks = 4